import React from "react";
import { FaEye } from "react-icons/fa";
import { FaBullseye } from "react-icons/fa6";

export const VisionMission = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">

      <div className="max-w-7xl mx-auto px-4">

        {/* TITLE */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Our Vision & Mission
          </h2>

          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            Driving innovation in learning by empowering individuals with the
            knowledge, skills, and opportunities needed to succeed in the
            modern digital world.
          </p>
        </div>

        {/* CARDS */}
        <div className="grid md:grid-cols-2 gap-10">

          {/* VISION */}
          <div className="group bg-white rounded-2xl p-10 shadow-md hover:shadow-xl transition duration-300 border border-gray-100">

            <div className="w-14 h-14 bg-primary-600 text-white flex items-center justify-center rounded-xl text-xl mb-6">
              <FaEye />
            </div>

            <h3 className="text-2xl font-semibold mb-4">
              Our Vision
            </h3>

            <p className="text-gray-600 leading-relaxed">
                          To become a leading and trusted learning platform that delivers high-quality,structured courses, hands-on projects, and expert mentorship, empowering learners with  job-ready skills that bridge the gap between academic knowledge and real-world career success.
            </p>
          </div>

          {/* MISSION */}
          <div className="group bg-white rounded-2xl p-10 shadow-md hover:shadow-xl transition duration-300 border border-gray-100">

            <div className="w-14 h-14 bg-secondary-600 text-white flex items-center justify-center rounded-xl text-xl mb-6">
              <FaBullseye />
            </div>

            <h3 className="text-2xl font-semibold mb-4">
              Our Mission
            </h3>

            <p className="text-gray-600 leading-relaxed">
                          Our mission is to deliver high-quality, industry focused education through structured courses, hands-on projects, and expert mentorship. We strive to equip learners with practical, job-ready skills that bridge the gap between academic learning and real-world career opportunities.
            </p>

          </div>

        </div>

      </div>

    </section>
  );
};